import type { PassageApiItem } from "../../../pages/planification-logistique/planificateur/planningTypes";
import { passageStatutLecture } from "../../../pages/planification-logistique/planificateur/planningDashboardUtils";

/** Libellé principal colonne « statut » exécution — serveur prioritaire. */
export function passageExecutionOperationalColumnLabel(p: PassageApiItem): string {
  const v = p.executionOperationalLabelFr?.trim();
  if (v) return v;
  return passageStatutLecture(p).title;
}

export const PASSAGE_OPERATIONAL_BADGE_CLASS: Record<string, string> = {
  Conforme: "bg-emerald-500/15 text-emerald-300 ring-emerald-500/30",
  "Validation requise": "bg-amber-500/15 text-amber-200 ring-amber-500/25",
  "GPS suspect": "bg-rose-500/15 text-rose-200 ring-rose-500/30",
  "Photos manquantes": "bg-amber-500/15 text-amber-200 ring-amber-500/35",
  Facturable: "bg-violet-500/15 text-violet-200 ring-violet-500/25",
  Rejeté: "bg-rose-500/15 text-rose-200 ring-rose-500/25",
  Clôturé: "bg-slate-600/40 text-slate-200 ring-slate-500/30",
  Annulé: "bg-slate-700/50 text-slate-400 ring-slate-600/40",
};
